import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from "../index";
import { fetchRefunds } from "../../actions/callrecorder/refundsActions";

export interface RefundInterface {
  id: number;
  user_id: number;
  product_id: number | null;
  productid: string | null;
  platform: string | null;
  transaction_id: string | null;
  status: string;
  amount: string | null;
  price: string | null;

  refunded_at: string;
  refund_reason: string | null;
  refund_source: string | null;

  created_at: string;
  updated_at: string;
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,
};

const adaptor = createEntityAdapter<RefundInterface>();

const slice = createSlice({
  name: 'refunds',
  initialState: adaptor.getInitialState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchRefunds.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchRefunds.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.refunds;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchRefunds.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  selectById: selectRefundById,
  selectIds: selectRefundIds,
  selectEntities: selectRefundEntities,
} = adaptor.getSelectors<RootState>(state => state.callrecorder.refunds);
